var exports = {
  "SP": "closeMarkersDialogButton__s0cFTR",
  "F1": "markersWrapper__3C2uUx",
  "se": "markersDialogActive__2beZ12",
};

module.exports = exports;
